import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=7bac0914&scoped=true&lang=pug&"
import script from "./PageTitle.vue?vue&type=script&lang=js&"
export * from "./PageTitle.vue?vue&type=script&lang=js&"
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=7bac0914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac0914",
  null
  
)

export default component.exports